import React from 'react';
import { DomainNs } from 'ReactApp/Types/DomainNs';
import { observer } from "mobx-react";
import ImageV1 from 'ReactApp/Components/ImageV1/ImageV1';
import BadgeListV1 from 'ReactApp/Components/BadgeListV1/BadgeListV1';
import LinkV1 from 'ReactApp/Components/LinkV1/LinkV1';
import PriceBlockV2 from 'ReactApp/Components/PriceBlockV2/PriceBlockV2';
import splitLine from 'ReactApp/Services/MotionHelpers/SplitLine';

type ProductCardV7Props = {
    card: DomainNs.ProductCardV7Interface,
    cardIndex: number,
    isReadonlyMode: boolean,
}

const ProductCardV7 = observer((props: ProductCardV7Props) => {

    return (
        <div className="product-card-v7">
            <div className="product-card-v7__badge-column">
                <BadgeListV1 {...{
                    badges: props.card.badges 
                }} />
            </div>
            <div className="product-card-v7__image-column">
                {props.card.images.currentImage !== null && (
                    <ImageV1 {...{
                        src: props.card.images.currentImage.src,
                        alt: props.card.images.currentImage.alt,
                        loading: 'lazy'
                    }} />
                )}
            </div>
            <div className="product-card-v7__title-column">
                <LinkV1 {...{
                    href: (props.card.url as string),
                    label: `Ваш подарок: ${(props.card.title as string)}`,
                    classes: [
                        'link-v1_text-color-type-text',
                        'link-v1_decoration-type-none'
                    ]
                }} />
                {props.card.currentRealModifier !== undefined && (
                    <div className="product-card-v7__rm">
                        Размер:&nbsp;
                        <strong>{props.card.currentRealModifier.label}</strong>
                    </div>
                )}
                {props.card.currentVirtualModifierAsTextile !== undefined && (
                    <div className="product-card-v7__vm">
                        Ткань:&nbsp;
                        <div className="textile-switcher-v1">
                            <div className="textile-switcher-v1__collection-block">
                                <div className="textile-switcher-v1__option-wrap">
                                    <div
                                        className={[
                                            'textile-switcher-v1__option-block',
                                            'textile-switcher-v1__option-block_active',
                                        ].join(' ')}
                                        >
                                        <div className="textile-switcher-v1__option-image">                                                                        
                                            <img 
                                                className="image-v1"
                                                loading="lazy" 
                                                src={props.card.currentVirtualModifierAsTextile.imgSrc} 
                                                alt={props.card.currentVirtualModifierAsTextile.imgAlt}
                                                />
                                        </div>
                                        <div className='textile-switcher-v1__option-name'>
                                            {splitLine(props.card.currentVirtualModifierAsTextile.textileLabel)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div className="product-card-v7__price-column">
                <PriceBlockV2 {...{
                    salePrice: props.card.salePrice,
                    oldPrice: props.card.oldPrice,
                    isGift: true,
                }} />
            </div>
            <div className="product-card-v7__action-column"></div>
        </div>
    );

})

export default ProductCardV7;